export const mkPath = (...ps) => {
    return ps;
};
let pathToURLImpl = () => { throw 'not implemented'; };
export const configurePathToURL = (strategy) => {
    pathToURLImpl = strategy.pathToURL;
};
export const pathToURL = (path) => pathToURLImpl(path);
const getURL = (path) => (params) => {
    if (!params)
        return pathToURL(path);
    return pathToURL(path.map(segment => {
        if (segment.startsWith('$')) {
            const paramName = segment.slice(1);
            return params[paramName];
        }
        return segment;
    }));
};
export const mkUrl = (path, permissions = []) => {
    return {
        path,
        permissions,
        'getURL': getURL(path),
    };
};
export const mkUrlNav = (path, permissions = [], options) => {
    return {
        path,
        permissions,
        'getURL': getURL(path),
        'nav': options.nav,
    };
};
export const obscureUrl = (url) => ({
    'path': url.path,
    'permissions': url.permissions,
    'nav': url.nav ? {
        'display': url.nav,
        'url': url.getURL,
    } : undefined,
});
export const obscureUrls = (urls) => Object.values(urls).map(obscureUrl);
